export const NOTIFICATION_TYPE = {
    GEN_INFO: "GEN_INFO",
    TREATMENT: "TREATMENT",
    TRACKING: "TRACKING",
    HEALTH_DATA: "HEALTH_DATA",
    REWARDS: "REWARDS",
    SUBSCRIPTION: "SUBSCRIPTION",
    ADM_NOTIF: "ADM_NOTIF",
    SOCIAL_GRP: "SOCIAL_GRP",
    CONTENT: "CONTENT",
    REMINDER: "REMINDER",
    PET_ORDER: "PET_ORDER",
    PAID_ORDER: "PAID_ORDER",
    PRODUCT: "PRODUCT",
    DOG_PURCHASE: "DOG_PURCHASE",
    CONTACT_US: "CONTACT_US",
    BREEDER: "BREEDER",
    PUPPY_SELL: "PUPPY_SELL",
    PUPPY_PURCHASE: "PUPPY_PURCHASE",
    ADM_USER_NOTES: "ADM_USER_NOTES",
};

export const NOTIFICATION_ICON = {
    GEN_INFO: "gen-info.png",
    TREATMENT: "treatment.png",
    TRACKING: "tracking.png",
    HEALTH_DATA: "health-data.png",
    REWARDS: "rewards.png",
    SUBSCRIPTION: "subscription.png",
    ADM_NOTIF: "pet-details.png",
    SOCIAL_GRP: "social-club-icon.png",
    CONTENT: "social-club-icon.png",
    REMINDER: "gen-info.png",
    PET_ORDER: "dog-purchase.png",
    PAID_ORDER: "dog-purchase-paid.png",
    PRODUCT: "subscription.png",
    DOG_PURCHASE: "dog-purchase.png",
    CONTACT_US: "pet-details.png",
    BREEDER: "dog-purchase.png",
    PUPPY_SELL: "dog-purchase.png",
    PUPPY_PURCHASE: "dog-purchase.png",
    ADM_USER_NOTES: "gen-info.png",
};
